import React, { useContext } from 'react';
import { Box, Grid } from '@mui/material';
import CalculateIcon from '@mui/icons-material/Calculate';
import { AuthContext } from '../../../context/logeduser';
import PageHeader from '../PageHeader';
import TaxCalculatorForm from '../../taxCalculator/TaxCalculatorForm';
import TaxSlabsPanel from '../../taxCalculator/TaxSlabsPanel';
import TaxCalculatorInfo from '../../taxCalculator/TaxCalculatorInfo';

export default function TaxCalculatorEmp() {
  const { authData } = useContext(AuthContext);
  const employeeNo = authData?.employee_no;

  return (
    <Box sx={{ pb: { xs: 4, md: 2 } }}>
      <PageHeader
        icon={<CalculateIcon />}
        title="Income Tax Calculator"
        subtitle={(
          <>
            Calculate your income tax for FY 2026-27 (AY 2027-28). Your salary details are pre-filled
            from your salary master — edit any field or click <strong>Clear</strong> to model a what-if scenario.
          </>
        )}
      />

      <Grid container spacing={3}>
        <Grid item xs={12} md={7}>
          <TaxCalculatorForm employeeNo={employeeNo} />
        </Grid>
        <Grid item xs={12} md={5}>
          <TaxSlabsPanel />
        </Grid>
      </Grid>

      <Box sx={{ mt: 3 }}>
        <TaxCalculatorInfo />
      </Box>
    </Box>
  );
}
